import axios from "axios";
import { getConfig } from "../../../../ApiHelpers/ApiDefaultConfig";
import { GetAnonChatsResponse, GetAnonChatMessagesResponse, ChatMessage } from "./models";

export const getAnonChats = async (body: { page: number, searchValue: string }): Promise<GetAnonChatsResponse | null> => {
    let config = getConfig()
    let result: GetAnonChatsResponse | null = null
    try {
        const response = await axios.get(`/anon-chat?page=${body.page}&searchValue=${body.searchValue}`, config)
        result = response.data
    } catch (error) {
        console.log(error, 'error')
    }

    return result
}


export const getAnonChatMessages = async (body: { page: number, chatId: string }): Promise<GetAnonChatMessagesResponse | null> => {
    let config = getConfig()
    let result: GetAnonChatMessagesResponse | null = null
    try {
        const response = await axios.get(`/anon-chat/chat-messages/${body.chatId}?page=${body.page}`, config)
        result = response.data
    } catch (error) {
        console.log(error, 'error')
    }

    return result
}


export const sendChatImage = async (formData: FormData): Promise<{ success: boolean, message: ChatMessage }> => {
    const config = getConfig(formData)
    try {
        let result = await axios.post(`/anon-chat/new-image-message`, formData, config)
        return result.data
    } catch (error) {
        return error as any
    }
}
 